import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function PredictingTransferRate() {
    return (
        <React.Fragment>
            <p>
                {' '}
                In addition to the network environment, transfer rates to file systems are constrained by the
                destination server's disk access speed. This impacts large data sets of small files because each file is
                written to disk when transferred.
            </p>
            <p>
                Other factors that may impact the transfer rates for data sets comprised of small files include the
                application of access-control lists (ACLs), the number of tasks vying for disk space, and the number of
                errors generated and logged.
            </p>
            <p>
                <strong>Note</strong>: A caching disk controller on the destination server will not increase the
                transfer speed.
            </p>

            <h5>Required Calculation Variables</h5>

            <ul>
                <li>Your disk's average seek time in msec</li>
                <br />
                <li>Your disk's average rotational latency in msec</li>
                <br />
                <li>Your total transfer data size in MB</li>
                <br />
                <li>Number of files to transfer</li>
                <br />
                <li>Available bandwidth in bits/second</li>
            </ul>

            <p>To calculate the potential transfer rate:</p>
            <br />

            <ol>
                <li>Calculate the average file size in bytes:</li>
                <p>(total data size x 1024 x 1024)/(number of files in the transfer)</p>
                <br />

                <li>Calculate the maximum number files which can be written per second:</li>
                <p>(1000/((disk's average seek time + disk's average rotational latency) x 2)</p>
                <br />

                <li>Calculate the maximum theoretical transfer rate in bytes per second</li>
                <p>(calculated average file size) x (calculated maximum file size)</p>
                <br />
            </ol>

            <h3>Example Calculation</h3>

            <ul>
                <li>Seek Time - 9 msec</li>
                <li>Rotational Latency - 1 msec</li>
                <li>Total Transfer Data Size - 4000 MB</li>
                <li>Number of Files - 55 000 000</li>
                <li>Available Bandwidth - 700 000 000 bits/second</li>
            </ul>

            <p>Average file size in bytes: (4000 x 1024 x 1024) / (55 000 000) = 76</p>
            <br />
            <p>Maximum files written per second: 1000 / ((9+1) x 2)) = 50 </p>
            <br />
            <p>Maximum theoretical transfer rate in bytes per second: 76 x 50 = 3800</p>
            <br />
        </React.Fragment>
    );
}

PredictingTransferRate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PredictingTransferRate);
